import clsx from "clsx"
import { CircularProgress } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

import ButtonBase, { TitanButtonColor } from "../ButtonBase"
import ConfirmButton, { IConfirmButtonProps } from "./ConfirmButton"

const defaultInProgressText = <>Submitting&hellip;</>

interface IReactiveConfirmButtonProps extends IConfirmButtonProps {
  inProgress?: boolean
  inProgressText?: JSX.Element | string
}

const useStyles = makeStyles(theme => ({
  progressCondensed: {
    marginLeft: 2,
    marginRight: 2
  }
}))

const ReactiveConfirmButton: React.FunctionComponent<IReactiveConfirmButtonProps> = ({
  inProgress = false,
  inProgressText = defaultInProgressText,
  ...props
}) => {
  const { children, disabled, onClick, ...inProgressProps } = props
  const { condensed = false } = props
  const classes = useStyles()

  return inProgress ? (
    <ButtonBase
      {...inProgressProps}
      startIcon={
        <CircularProgress
          className={clsx({ [classes.progressCondensed]: condensed })}
          size={condensed ? "0.5em" : "0.75em"}
          color="inherit"
        />
      }
      color={TitanButtonColor.Grey}
      variant="contained"
      disableRipple
      disableFocusRipple
    >
      {inProgressText}
    </ButtonBase>
  ) : (
    <ConfirmButton {...props} />
  )
}

export default ReactiveConfirmButton
